import script from "./DetalleTorneoLiveEquiposView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleTorneoLiveEquiposView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleTorneoLiveEquiposView.vue?vue&type=style&index=0&id=f80a5d1e&lang=css"

const __exports__ = script;

export default __exports__